import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const ProgramLevelsRedux = createActions(
  {
    // Custom actions
  },
  {
    prefix: 'PROGRAM_LEVELS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = ProgramLevelsRedux
export const ProgramLevelsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
// custom state
},
{
  get: true,
  // Default state
})

export const reducer = createReducer(
  INITIAL_STATE, {
    // custom reducers
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ProgramLevelsRedux.js